// S1: Sitzung auffrischen - reine Regeln, ohne Importe.
export const AUFFRISCHEN_MS = 60 * 60 * 1000;
export const VORAB_ABMELDEN_MS = 12 * 60 * 60 * 1000;

// Höchstens einmal in 60 Minuten.
export function sollAuffrischen(letzteMs, jetztMs) {
  return !letzteMs || jetztMs - letzteMs >= AUFFRISCHEN_MS;
}

// Weniger als 12 Stunden bis zur 30-Tage-Grenze: lieber jetzt kontrolliert abmelden als mitten in einer Eingabe.
export function sollVorabAbmelden(spaetestensBisIso, jetztMs) {
  const grenze = Date.parse(spaetestensBisIso || '');
  return Number.isFinite(grenze) && grenze - jetztMs < VORAB_ABMELDEN_MS;
}

// Neues Token nur übernehmen, wenn noch genau das Token gespeichert ist, mit dem die Anfrage losging
// (sonst: nach dem Abmelden wieder hineingeschrieben oder ein neueres Token überschrieben).
export function tokenUebernehmen(tokenBeiStart, tokenJetzt, neuesToken) {
  return Boolean(neuesToken) && Boolean(tokenBeiStart) && tokenBeiStart === tokenJetzt;
}
